export const patterns = {
  seps: /[\s,/._-]+/g,
  period: /\./,
  all_periods: /\./g,
  word_start: /\b(\w)/g,
  settings: /^settings?\./,
  features: /^features?\./,
  filter: /^filter\./,
  data: /^data\./,
  variables: /^variables?\./,
  properties: /prop/,
  palette: /^pal/,
  datasets: /^dat/,
  variable: /^var/,
  levels: /^lev/,
  ids: /^ids/,
  minmax: /^m[inax]{2}$/,
  int_types: /^(?:year|int|integer)$/,
  end_punct: /[.?!]$/,
  mustache: /\{([^}]+)\}/g,
  measure_name: /(?:^measure|_name)$/,
  http: /^https?:\/\//,
  bool: /^(?:true|false)$/,
  number: /^[\d-][\d.,]*$/,
  leading_zeros: /^0+/,
  url_spaces: /%20/g,
  hashes: /#/g,
  embed_setting: /^(?:hide_|navcolor|close_menus)/,
  median: /^med/i,
  location_string: /^[^?]*/,
  time_ref: /\{time\}/g,
  pre_colon: /^[^:]*:/,
  exclude_query: /^(?:features|time_range|id)$/,
  space: /\s+/,
  has_html: /<(?:math|a|br)[/\s>]/,
  href: /\\(?:href|url)\{([^}]+)\}(?:\{([^}]+)\})?/g,
  bracket_content: /(?:^|>)[^<]*(?:<|$)/,
  html_tags: /^(?:semantics|m|a|br)/,
  html_attributes:
    /^(?:xmlns|display|style|encoding|stretchy|alttext|scriptlevel|fence|math|separator|href|rel|target)/,
  id_escapes: /(?<=#[^\s]+)([.[\](){}?*-])/g,
  repo: /\.com[/:]([^\/]+\/[^\/]+)/,
  basename: /^.*\//,
}
